import { createSlice } from "@reduxjs/toolkit"

interface SocketState {
  response: string
  receivingResponse: boolean
  SendMessage: (message: string) => void
}

const initialState: SocketState = {
  response: "",
  receivingResponse: false,
  SendMessage: () => {},
}

const socketStore = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setReceivingResponse: (state, action) => ({
      ...state,
      receivingResponse: action.payload,
    }),
    appendResponseText: (state, action) => ({
      ...state,
      response: state.response + action.payload,
    }),
    clearResponse: (state) => ({
      ...state,
      response: "",
    }),
    setSendMessage: (state, action) => ({
      ...state,
      SendMessage: action.payload,
    }),
  },
})

export const { setReceivingResponse, appendResponseText, clearResponse, setSendMessage } = socketStore.actions

export default socketStore.reducer
